import * as yup from 'yup';

const schema = yup.object().shape({
  demand_inputs: yup.array().required()
});

export default schema;
